(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[486],{

/***/ 80039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90171);
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(t,r,i,o){void 0===i&&(i=__webpack_require__.g),void 0===o&&(o={});var c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(),u=o.capture,a=o.passive,v=o.once;(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function(){c.current=r},[r]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function(){if(i&&i.addEventListener){var e=function(e){return c.current(e)},n={capture:u,passive:a,once:v};return i.addEventListener(t,e,n),function(){i.removeEventListener(t,e,n)}}},[t,i,u,a,v])}


/***/ }),

/***/ 53068:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-checkout/cart-button",
      function () {
        return __webpack_require__(78716);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "MU": function() { return /* binding */ setListener; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
var safeGetLocalStorage = function() {
    try {
        return window === null || window === void 0 ? void 0 : window.localStorage;
    } catch (err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to local storage
        return undefined;
    }
};
var setListener = function(cb) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    window.addEventListener("storage", function(e) {
        cb(e);
    });
};
var setItem = function(key, value) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
};
var getItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return JSON.parse(string);
};
var removeItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
};


/***/ }),

/***/ 37175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rV": function() { return /* binding */ getItem; },
  "cl": function() { return /* binding */ removeItem; },
  "LS": function() { return /* binding */ setItem; }
});

// UNUSED EXPORTS: isAvailable

// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/local-storage.js
var local_storage = __webpack_require__(59371);
;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/broadcast-message.js
/* eslint-disable import/prefer-default-export */ 
var broadcastMessageToTabs = function(key, value) {
    (0,local_storage/* setItem */.LS)(key, value);
    (0,local_storage/* removeItem */.cl)(key);
};

;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/session-storage.js

var safeGetSessionStorage = function() {
    try {
        return window === null || window === void 0 ? void 0 : window.sessionStorage;
    } catch (err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to session storage
        return undefined;
    }
};
var isAvailable = function() {
    return !!safeGetSessionStorage();
};
var getItem = function(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return JSON.parse(string);
};
var setItem = function(key, value) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _broadcast = ref.broadcast, broadcast = _broadcast === void 0 ? false : _broadcast;
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
    if (broadcast) {
        broadcastMessageToTabs("BROADCAST", {
            key: key,
            data: value
        });
    }
};
var removeItem = function(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
};


/***/ }),

/***/ 85391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62204);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59371);
/* harmony import */ var _components_common_segment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5721);




var isInternalUser = function isInternalUser() {
    var internalUser = (0,_purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_1__/* .getItem */ .rV)("internal-user");
    if (!internalUser) {
        return false;
    }
    return internalUser.isInternalUser === true;
};
var isKnownBot = function isKnownBot() {
    var BOTS = /(pingdom)|(google)/i;
    return __webpack_require__.g.navigator.userAgent.match(BOTS);
};
var FilterWrapper = {
    identify: function identify(userId, traits, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.identify */ .W.identify(userId, traits, options, callback);
        } else {
            // eslint-disable-next-line no-console
            console.log("INTERNAL USER - Identify: ", userId);
        }
    },
    track: function track(event, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.track */ .W.track(event, properties, options, callback);
        } else {
            // eslint-disable-next-line no-console
            console.log("INTERNAL USER - Track: ", event, properties, options, callback);
        }
    },
    page: function page(category, name, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.page */ .W.page(category, name, properties, options, callback);
        } else {
            // eslint-disable-next-line no-console
            console.log("INTERNAL USER - Page: ", category, name, properties, options, callback);
        }
    }
};
var Analytics = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, FilterWrapper), {
    trackTagScanned: function trackTagScanned(param) {
        var itemId = param.itemId, scannedCode = param.scannedCode, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackTagScanned()");
        }
        if (!scannedCode) {
            throw new Error("No scannedCode provided to Analytics.trackTagScanned()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackTagScanned()");
        }
        FilterWrapper.track("Tag Scanned", {
            itemId: itemId,
            scannedCode: scannedCode,
            shopCode: shopCode
        });
    },
    trackCodeEntered: function trackCodeEntered(param) {
        var enteredCode = param.enteredCode, codeType = param.codeType;
        if (!enteredCode) {
            throw new Error("No enteredCode provided to Analytics.trackCodeEntered()");
        }
        if (!codeType) {
            throw new Error("No codeType provided to Analytics.trackCodeEntered()");
        }
        if (codeType === "tag") {
            FilterWrapper.track("Tag Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "item") {
            FilterWrapper.track("Shareable Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "external") {
            FilterWrapper.track("External Shop Code Entered", {
                enteredCode: enteredCode
            });
        }
    },
    trackInstagramLinkFollowed: function trackInstagramLinkFollowed(param) {
        var itemId = param.itemId, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackInstagramLinkFollowed()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackInstagramLinkFollowed()");
        }
        FilterWrapper.track("Instagram Link Followed", {
            itemId: itemId,
            shopCode: shopCode
        });
    },
    trackImageGalleryInteraction: function trackImageGalleryInteraction(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackImageViewed()");
        }
        FilterWrapper.track("Interacted with Image Gallery", {
            itemId: itemId
        });
    },
    trackProductViewed: function trackProductViewed(param) {
        var itemId = param.itemId, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackProductViewed()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackProductViewed()");
        }
        FilterWrapper.track("Product Viewed", {
            itemId: itemId,
            slug: slug,
            product_id: slug
        });
    },
    trackCheckoutStarted: function trackCheckoutStarted(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackCheckoutStarted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackCheckoutStarted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackCheckoutStarted()");
        }
        FilterWrapper.track("Checkout Started", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug,
            product_id: slug
        });
    },
    trackOrderSubmitted: function trackOrderSubmitted(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackOrderSubmitted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackOrderSubmitted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackOrderSubmitted()");
        }
        FilterWrapper.track("Order Submitted", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug
        });
    },
    trackOrderCreated: function trackOrderCreated(param) {
        var orderReference = param.orderReference;
        if (!orderReference) {
            throw new Error("No orderReference provided to Analytics.trackOrderCreated()");
        }
        FilterWrapper.track("Order Created", {
            orderReference: orderReference
        });
    },
    trackOrderFailed: function trackOrderFailed() {
        FilterWrapper.track("Order Failed");
    },
    trackShippingMethodSelected: function trackShippingMethodSelected(param) {
        var shippingOption = param.shippingOption;
        if (!shippingOption) {
            throw new Error("No shippingOption provided to Analytics.trackShippingMethodSelected()");
        }
        FilterWrapper.track("Shipping Method Selected", {
            shippingOption: shippingOption
        });
    },
    trackPaymentMethodSelected: function trackPaymentMethodSelected(param) {
        var paymentMethod = param.paymentMethod;
        if (!paymentMethod) {
            throw new Error("No paymentMethod provided to Analytics.trackPaymentMethodSelected()");
        }
        FilterWrapper.track("Payment Method Selected", {
            paymentMethod: paymentMethod
        });
    },
    trackLearnMoreClicked: function trackLearnMoreClicked() {
        FilterWrapper.track("Learn More Clicked");
    },
    trackLearnMoreModalDismissed: function trackLearnMoreModalDismissed() {
        FilterWrapper.track("Learn More Modal Dismissed");
    },
    trackSizeChanged: function trackSizeChanged(param) {
        var itemId = param.itemId, selectedItemId = param.selectedItemId, slug = param.slug;
        FilterWrapper.track("Size Changed", {
            itemId: itemId,
            selectedItemId: selectedItemId,
            slug: slug
        });
    },
    trackMerchantItemUrlVisit: function trackMerchantItemUrlVisit(param) {
        var source = param.source, itemMerchantUrl = param.itemMerchantUrl;
        FilterWrapper.track("Item Merchant Link Visited", {
            source: source,
            itemMerchantUrl: itemMerchantUrl
        });
    },
    trackTrendingItemSelected: function trackTrendingItemSelected(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Trending Item Selected", {
            itemId: itemId,
            slug: slug
        });
    },
    trackTrendingScrolled: function trackTrendingScrolled() {
        FilterWrapper.track("Trending Scrolled");
    },
    trackRetailerModalOpened: function trackRetailerModalOpened() {
        FilterWrapper.track("Retailer Modal Opened");
    },
    trackShareModalOpened: function trackShareModalOpened(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Share Modal Opened", {
            itemId: itemId,
            slug: slug
        });
    },
    trackLastSeenProductClicked: function trackLastSeenProductClicked() {
        FilterWrapper.track("Last Seen Product Clicked");
    },
    trackInputChanged: function trackInputChanged(param) {
        var name = param.name;
        if (!name) {
            throw new Error("No name provided to Analytics.trackInputChanged");
        }
        FilterWrapper.track("".concat(name, " Changed"));
    },
    trackSectionExpanded: function trackSectionExpanded(param) {
        var title = param.title;
        if (!title) {
            throw new Error("No title provided to Analytics.trackSectionExpanded");
        }
        FilterWrapper.track("".concat(title, " Expanded"));
    },
    trackShareLinkFollowed: function trackShareLinkFollowed(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No title provided to Analytics.trackShareLinkFollowed");
        }
        FilterWrapper.track("Unique Product Share Link Followed", {
            itemId: itemId
        });
    },
    trackNewsletterSignup: function trackNewsletterSignup() {
        FilterWrapper.track("Newsletter Sign Up");
    },
    trackSuggestClicked: function trackSuggestClicked() {
        FilterWrapper.track("Suggest an Item Clicked");
    },
    trackSuggestionSubmitted: function trackSuggestionSubmitted() {
        FilterWrapper.track("Suggestion Submitted");
    },
    trackExplainerVideoPlayed: function trackExplainerVideoPlayed() {
        FilterWrapper.track("Explainer Video Played");
    },
    trackExplainerVideoPaused: function trackExplainerVideoPaused(param) {
        var timeViewed = param.timeViewed;
        FilterWrapper.track("Explainer Video Paused", {
            timeViewed: timeViewed
        });
    },
    trackUserProgressed: function trackUserProgressed(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserProgressed");
        }
        FilterWrapper.track("User Progressed", {
            pageName: pageName
        });
    },
    trackUserEngagedWithLandingPage: function trackUserEngagedWithLandingPage(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserEngagedWithLandingPage");
        }
        FilterWrapper.track("Engaged With Landing Page", {
            pageName: pageName
        });
    },
    trackSizeGuideClicked: function trackSizeGuideClicked() {
        FilterWrapper.track("Size Guide Clicked");
    },
    trackVisitDemoStoreClicked: function trackVisitDemoStoreClicked() {
        FilterWrapper.track("Visit Demo Store Clicked");
    },
    trackGetInTouchClicked: function trackGetInTouchClicked() {
        FilterWrapper.track("Get In Touch Clicked");
    },
    trackMerchantContactFormSubmitted: function trackMerchantContactFormSubmitted() {
        FilterWrapper.track("Merchant Contact Form Submitted");
    },
    trackStoreSignupReview: function trackStoreSignupReview() {
        FilterWrapper.track("Store Review Form Submitted");
    },
    trackSurveyCTAClick: function trackSurveyCTAClick() {
        FilterWrapper.track("Survey CTA Clicked");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Analytics);


/***/ }),

/***/ 81810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _EmbeddedPage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19740);

/* harmony default export */ __webpack_exports__["Z"] = (_EmbeddedPage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 78716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cart_button; }
});

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(81142);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62204);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(38137);
// EXTERNAL MODULE: ../../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(60586);
// EXTERNAL MODULE: ../../../../../node_modules/@juggle/resize-observer/lib/exports/resize-observer.js + 23 modules
var resize_observer = __webpack_require__(69502);
// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/local-storage.js
var local_storage = __webpack_require__(59371);
// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/session-storage.js + 1 modules
var session_storage = __webpack_require__(37175);
// EXTERNAL MODULE: ../../../../../node_modules/@use-it/event-listener/dist/event-listener.m.js
var event_listener_m = __webpack_require__(80039);
// EXTERNAL MODULE: ../../../../../node_modules/react/index.js
var react = __webpack_require__(90171);
// EXTERNAL MODULE: ../../../../../node_modules/react-async/dist-web/index.js
var dist_web = __webpack_require__(82622);
// EXTERNAL MODULE: ../../../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(24686);
;// CONCATENATED MODULE: ./components/EmbeddedApp/CartButton/AlertIcon.jsx
/* eslint-disable import/prefer-default-export */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  height: ",
        ";\n  width: ",
        ";\n  background: #8f17d1;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var AlertIcon = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), function(param) {
    var styling = param.styling;
    return styling.padding;
}, function(param) {
    var styling = param.styling;
    return styling.padding;
}, function(param) {
    var styling = param.styling;
    return "calc((".concat(styling.height, " - ").concat(styling.padding, " * 2) * 0.375)");
}, function(param) {
    var styling = param.styling;
    return "calc((".concat(styling.width, " - ").concat(styling.padding, " * 2) * 0.375)");
});


;// CONCATENATED MODULE: ./components/EmbeddedApp/CartButton/Button.jsx
/* eslint-disable import/prefer-default-export */ 

function Button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* stylelint-disable */\n  display: block;\n  position: relative;\n\n  background: 0px;\n  border: 0px;\n  width: 100%;\n  padding: 0px;\n  margin: 0px;\n  line-height: 0px;\n  cursor: pointer;\n  padding: ",
        ";\n\n  & > svg > circle,\n  & > svg > line {\n    stroke: ",
        ";\n    stroke-width: ",
        ";\n  }\n  /* stylelint-enable */\n"
    ]);
    Button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Button = function Button(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, (0,_object_spread/* default */.Z)({
        type: "button",
        id: "cart-button"
    }, props));
};
var StyledButton = styled_components_browser_esm/* default.button */.ZP.button(Button_templateObject(), function(param) {
    var styling = param.styling;
    return styling.padding;
}, function(param) {
    var styling = param.styling;
    return styling.fill;
}, function(param) {
    var styling = param.styling;
    return styling.strokeWidth;
});


;// CONCATENATED MODULE: ./components/EmbeddedApp/CartButton/ClockIcon.jsx
/* eslint-disable import/prefer-default-export */ 

var ClockIcon = function ClockIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "white",
                strokeWidth: "2",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "11.75",
                y1: "13",
                x2: "11.75",
                y2: "7",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "11.5",
                y1: "12.5",
                x2: "16.5",
                y2: "16.5",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    });
};


// EXTERNAL MODULE: ./components/EmbeddedApp/PageTypes/IframePage/index.js
var IframePage = __webpack_require__(81810);
// EXTERNAL MODULE: ./components/EmbeddedApp/checkout-api.js
var checkout_api = __webpack_require__(77799);
// EXTERNAL MODULE: ./webserver-page.jsx
var webserver_page = __webpack_require__(13393);
;// CONCATENATED MODULE: ./pages/embedded-checkout/cart-button.jsx



function cart_button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  body {\n    background: none transparent;\n  }\n\n  ",
        "\n"
    ]);
    cart_button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var CartButtonIframe = function CartButtonIframe(param) {
    var secureSessionToken = param.secureSessionToken, showButton = param.showButton, checkoutId = param.checkoutId, instanceId = param.instanceId, initialStyle = param.style;
    var ref = (0,react.useState)(initialStyle), style = ref[0], setStyling = ref[1];
    var parentPage = CartParentPage({
        instanceId: instanceId
    });
    (0,react.useEffect)(function() {
        parentPage.loaded(showButton);
        var elem = document.body;
        var resizeObserver = new resize_observer/* ResizeObserver */["do"](function() {
            parentPage.sizeChanged(elem.offsetWidth, elem.offsetHeight);
        });
        resizeObserver.observe(elem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,event_listener_m/* default */.Z)("message", function(event) {
        var message = event.data;
        if ((message === null || message === void 0 ? void 0 : message.type) && (message === null || message === void 0 ? void 0 : message.data)) {
            var type = message.type, data = message.data;
            if (type === "UPDATE") {
                setStyling((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                    fill: data.fill
                }));
            }
        }
    });
    (0,event_listener_m/* default */.Z)("storage", function() {
        var checkoutSession = session_storage/* getItem */.rV("checkoutSession");
        var show = checkoutSession && checkoutSession.lineItems.length > 0;
        parentPage.postVisibilityChanged({
            show: show
        });
    });
    useSecureTokenEffect({
        secureSessionToken: secureSessionToken
    });
    useFetchCheckoutEffect({
        checkoutId: checkoutId
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IframePage/* default */.Z, {
        head: {},
        useSegment: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoBodyBackground, {
                globalCSS: "html,body { height: ".concat(style.height, "; width: ").concat(style.width, "; }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                styling: style,
                onMouseEnter: function onMouseEnter() {
                    // Check if we have a mouse and dont fire if we dont
                    if (!window.matchMedia("(pointer:fine)").matches) {
                        return;
                    }
                    parentPage.cartButtonEntered();
                },
                onClick: function onClick() {
                    parentPage.cartButtonClicked();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClockIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertIcon, {
                        "data-testid": "alert-icon",
                        styling: style
                    })
                ]
            })
        ]
    });
};
var NoBodyBackground = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(cart_button_templateObject(), function(param) {
    var globalCSS = param.globalCSS;
    return globalCSS || "";
});
function useSecureTokenEffect(param) {
    var secureSessionToken = param.secureSessionToken;
    if (secureSessionToken) {
        local_storage/* setItem */.LS("_pd_secure_session_token", secureSessionToken);
    }
}
/*
  Fetch and save the checkout session as soon as possible
  so the other components can use it
*/ function useFetchCheckoutEffect(param) {
    var checkoutId = param.checkoutId;
    var FetchCheckoutTask = (0,dist_web/* useAsync */.r5)({
        deferFn: checkout_api/* fetchCheckout */.PL,
        onResolve: function onResolve(data) {
            session_storage/* setItem */.LS("checkoutSession", data);
        },
        onReject: function onReject(err) {
            console.error("PurpleDot: Failed to fetch checkout for ".concat(checkoutId), err);
        }
    });
    (0,react.useEffect)(function() {
        if (checkoutId) {
            session_storage/* setItem */.LS("serverCheckoutId", checkoutId);
            FetchCheckoutTask.run({
                checkoutId: checkoutId
            });
        } else {
            session_storage/* removeItem */.cl("checkoutSession");
            session_storage/* removeItem */.cl("serverCheckoutId");
        }
    // eslint-disable-next-line
    }, []);
}
function CartParentPage(param) {
    var instanceId = param.instanceId;
    var sendMessage = function sendMessage(type, data) {
        window.parent.postMessage({
            meta: {
                placementType: "cart-button",
                instanceId: instanceId,
                type: type
            },
            data: data || {}
        }, "*");
    };
    if (!instanceId) {
        throw new Error("No instanceId provided");
    }
    return {
        loaded: function loaded(showButton) {
            sendMessage("loaded", {
                showButton: showButton
            });
        },
        sizeChanged: function sizeChanged(width, height) {
            sendMessage("window-size-changed", {
                width: width,
                height: height
            });
        },
        postVisibilityChanged: function postVisibilityChanged(param) {
            var show = param.show;
            sendMessage("visibility-changed", {
                show: show
            });
        },
        cartButtonEntered: function cartButtonEntered() {
            sendMessage("cart-button-entered");
        },
        cartButtonClicked: function cartButtonClicked() {
            sendMessage("cart-button-clicked");
        }
    };
}
/* harmony default export */ var cart_button = ((0,webserver_page/* default */.Z)(CartButtonIframe));


/***/ }),

/***/ 81669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 2647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(83825);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(81669);
;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assert_this_initialized/* default */.Z)(self);
}

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 83825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 35823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46859);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 78839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 46859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 99076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _wrapNativeSuper; }
});

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(46859);
;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(83825);
;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}


/***/ }),

/***/ 77233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(33651);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 66891:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(77233)();
}


/***/ }),

/***/ 33651:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8116,4634,2622,9502,9552,9740,7799,9774,2888,179], function() { return __webpack_exec__(53068); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);